import {
  faCirclePlay,
  faClipboard,
  faEdit
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getAssessment } from 'api/assessments';
import { Flex } from 'components';
import { Button } from 'components/_form';
import { Loader } from 'components/Loader/Loader';
import { useAssessmentContext } from 'contexts/AssessmentContext';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { IDetailedAssessment, IAssessment } from 'types/assessments';
import { IBlock } from 'types/methologies';
import { AssessmentModal } from '../../AssessmentModal/AssessmentModal';

interface Props {
  assessment: IAssessment;
}

export const OptionButtons: React.FC<Props> = ({ assessment }) => {
  const [loading, setLoading] = useState(false);
  const [selectedBlock, setSelectedBlock] = useState<IBlock>();
  const [detailedAssessments, setDetailedAssessments] = useState<
    IDetailedAssessment[]
  >([]);
  const { setAssessmentToEditId } = useAssessmentContext();

  const handleLaunchAssessment = async () => {
    setLoading(true);
    const detailedAssessmentRes = await getAssessment(assessment.id);

    if ('error' in detailedAssessmentRes) {
      toast.error(detailedAssessmentRes.error.message);
      return;
    }

    setDetailedAssessments([detailedAssessmentRes.data]);
    setSelectedBlock(detailedAssessmentRes.data.practice?.blocks[0]);
    setLoading(false);
  };

  return loading ? (
    <Loader />
  ) : (
    <Flex gap="10px" mx="auto" width="fit-content">
      <Button
        variant="green"
        onClick={handleLaunchAssessment}
        icon={<FontAwesomeIcon icon={faCirclePlay} />}
      />
      <Button
        variant="grey"
        bordered
        onClick={() => {}}
        icon={<FontAwesomeIcon icon={faClipboard} />}
      />
      <Button
        onClick={() => {
          setAssessmentToEditId(assessment.id);
        }}
        icon={<FontAwesomeIcon icon={faEdit} />}
      />

      {!!selectedBlock && (
        <AssessmentModal
          isOpen={!!selectedBlock}
          onCancelClick={() => {
            setSelectedBlock(undefined);
          }}
          usedEvalations={detailedAssessments}
          setUsedEvalations={setDetailedAssessments}
          selectedBlock={selectedBlock}
          setSelectedBlock={setSelectedBlock}
        />
      )}
    </Flex>
  );
};
